// extracted by mini-css-extract-plugin
export default {"popover":"CCAPopover-module__popover--UVvdp","popover_content":"CCAPopover-module__popover_content--LEcd6"};